<script>
import AdministrationManagementTableAction
  from '@/components/profile/administrationManagement/AdministrationManagementTableAction.vue'
export default {
  components: {
    TableAction: AdministrationManagementTableAction
  },
  props: {
    user: {
      type: Object
    },
    organization: {
      type: Object
    }
  },
  data: () => ({
    isLoading: false
  }),
  methods: {
    async toggleAdminStatus(user) {
      this.isLoading = true
      await this.$organizationService
        .toggleAdminStatus(user, this.organization)
        .then(async () => {
          this.$emit('promote')
          this.$notify(this.$t('global.action.success'), {type: 'success'})
        })
        .catch(() => {
          this.$notify(this.$t('global.action.error'), {type: 'error'})
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
<template>
  <div>
    <TableAction
      confirmation
      :icon="isLoading ? 'mdi-spin mdi-loading' : 'mdi-crown'"
      :color="user.isAdmin ? 'warning' : '#d5d5d5'"
      dialog-color="primary"
      @confirmed="toggleAdminStatus(user)">
      <template
        v-if="!user.isAdmin"
        slot="confirmationContent">
        <span
          v-html="$t('component.backoffice.organization.administratorToggle.action.confirmation.promote.user')"></span>
      </template>
      <template
        v-if="!user.isAdmin"
        slot="tooltip">
         <span
           v-html="$t('component.backoffice.organization.administratorToggle.tooltip.promote.user')"></span>
      </template>
      <template
        v-if="user.isAdmin"
        slot="confirmationContent">
        <span
          v-html="$t('component.backoffice.organization.administratorToggle.action.confirmation.promote.user.is.admin')">
        </span>
      </template>
      <template
        v-if="user.isAdmin"
        slot="tooltip">
        <span
          v-html="$t('component.backoffice.organization.administratorToggle.tooltip.promote.user.is.admin')"></span>
      </template>
    </TableAction>
  </div>
</template>
